import { JwtSessionData } from './jwt-session-data.js';
import { nowInSeconds } from '@iwentsourcing/core/utils/now-in-seconds.js';

export function buildJwtSessionData(
  realmName: string,
  tenant: string,
  provider: string,
  result: {
    id_token: string;
    refresh_token: string;
    expires_in: number;
    username: string;
  },
): JwtSessionData {
  return {
    tenant: tenant,
    realm: realmName,
    provider: provider,
    exp: nowInSeconds() + result.expires_in,
    accessToken: result.id_token,
    refreshToken: result.refresh_token,
    username: result.username,
  };
}
